import React, { useState } from "react";
import { Layout, Button, Drawer, Grid, Typography } from "antd";
import { MenuOutlined } from "@ant-design/icons";
import Sidebar from "./Sidebar";
import "./Sidebar.css";

const { Content, Sider } = Layout;
const { useBreakpoint } = Grid;
const { Text } = Typography;

const AdminLayout = ({
  selectedMenuItem,
  pageTitle,
  pageSubtitle,
  children,
  contentClassName = "",
}) => {
  const screens = useBreakpoint();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const isDesktop = screens.lg;

  const sidebar = (
    <Sidebar
      selectedMenuItem={selectedMenuItem}
      onNavigate={() => setDrawerOpen(false)}
    />
  );

  return (
    <Layout className="admin-shell">
      {isDesktop ? (
        <Sider width={292} className="admin-shell__sider">
          {sidebar}
        </Sider>
      ) : null}

      <Layout className="admin-shell__main">
        <Content className="admin-shell__content">
          <div className="admin-shell__mobilebar">
            <Button
              type="text"
              className="admin-shell__menu-trigger"
              icon={<MenuOutlined />}
              onClick={() => setDrawerOpen(true)}
            />
            <div className="admin-shell__mobilebar-copy">
              <Text className="admin-shell__eyebrow">Digital Shifts Admin</Text>
              {pageTitle ? (
                <Text className="admin-shell__mobile-title">{pageTitle}</Text>
              ) : null}
            </div>
          </div>

          <div className={`admin-page-shell ${contentClassName}`.trim()}>
            {(pageTitle || pageSubtitle) && (
              <div className="admin-page-shell__header">
                {pageTitle ? (
                  <Text className="admin-page-shell__title">{pageTitle}</Text>
                ) : null}
                {pageSubtitle ? (
                  <Text className="admin-page-shell__subtitle">
                    {pageSubtitle}
                  </Text>
                ) : null}
              </div>
            )}
            {children}
          </div>
        </Content>
      </Layout>

      <Drawer
        placement="left"
        closable={false}
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        className="admin-shell__drawer"
        bodyStyle={{ padding: 0 }}
        width={292}
      >
        {sidebar}
      </Drawer>
    </Layout>
  );
};

export default AdminLayout;
